var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgPhoneNotFound = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 59,
    height: 60,
    viewBox: "0 0 59 60",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.3664 44.0915L42.7351 41.565C43.7397 40.4934 45.2493 40.0562 46.6634 40.4536C49.5132 41.2544 52.9723 42.2917 55.3887 43.0544C57.1697 43.6166 58.08 45.4075 57.477 47.175C53.768 58.0464 45.5745 59.5643 41.6478 58.8503C17.7312 52.9488 5.28108 32.5783 2.0456 23.1307C-1.88517 8.71784 6.06749 3.05638 12.6136 1.48312C14.5404 1.02004 16.2956 2.44138 16.6639 4.3885L18.3104 13.0912C18.5766 14.4981 18.0716 15.9411 17.02 16.9128C16.2814 17.5952 15.4911 18.3404 14.8031 18.9942C13.6522 20.088 13.2556 21.7719 13.9198 23.2141C18.9288 34.0906 29.112 41.6503 36.0948 44.9879C37.5523 45.6845 39.2616 45.27 40.3664 44.0915Z",
    stroke: "#7B7B7B",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.3779 13.2511V17.289M37.3779 21.3269H37.388M47.4726 17.289C47.4726 22.8642 42.953 27.3837 37.3779 27.3837C31.8027 27.3837 27.2832 22.8642 27.2832 17.289C27.2832 11.7139 31.8027 7.19434 37.3779 7.19434C42.953 7.19434 47.4726 11.7139 47.4726 17.289Z",
    stroke: "#FF6057",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgPhoneNotFound, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/phoneNotFound.b174ac82.svg";
export { ForwardRef as ReactComponent };